<template>
    <div
        id="modal-message-status"
        aria-hidden="true"
        aria-labelledby="modalFillInLabel"
        class="modal animation opacity modal-default modal-delete"
        role="dialog"
        tabindex="-1"
    >
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <button aria-hidden="true" class="close" data-dismiss="modal" type="button">
                        <svg
                            height="16"
                            viewBox="0 0 10 10"
                            width="16"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                        >
                            <defs>
                                <path id="qczca" d="M1110 328l8-8" />
                                <path id="qczcb" d="M1110 320l8 8" />
                            </defs>
                            <g>
                                <g transform="translate(-1109 -319)">
                                    <g>
                                        <use
                                            fill="#fff"
                                            fill-opacity="0"
                                            stroke="#5937B7"
                                            stroke-linecap="square"
                                            stroke-miterlimit="50"
                                            stroke-width="1.5"
                                            xlink:href="#qczca"
                                        />
                                    </g>
                                    <g>
                                        <use
                                            fill="#fff"
                                            fill-opacity="0"
                                            stroke="#5937B7"
                                            stroke-linecap="square"
                                            stroke-miterlimit="50"
                                            stroke-width="1.5"
                                            xlink:href="#qczcb"
                                        />
                                    </g>
                                </g>
                            </g>
                        </svg>
                    </button>
                </div>
            </div>

            <strong>{{ __('Message not delivered') }}</strong>
            <p v-html="__(`Zpráva nebyla odeslána. Zkuste ji odeslat kliknutím na&nbsp;„Zkusit&nbsp;znovu“.`)"></p>
        </div>

        <div class="modal-body">
            <div class="btn-group">
                <VButton :label="__('Try again')" type="submit" @onClick="submit" />
                <VButton :label="__('Delete message')" color="danger" @onClick="remove" />
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    props: {
        message: {
            type: Object,
            required: false
        },
        send: {
            type: Boolean,
            required: true
        }
    },
    watch: {
        message() {
            if (this.message && this.message.success === false) {
                $('#modal-message-status').modal()
            }
        },
        send(send) {
            if (send === true) {
                Vuemit.fire('Button--sending-failed', true)
            }
        },
    },
    methods: {
        ...mapActions({
            sendMessage: 'chat/sendMessage',
            deleteMessage: 'chat/deleteMessage'
        }),
        remove() {
            this.deleteMessage(this.message)

            $('#modal-message-status').modal('hide')
        },
        submit() {
            this.deleteMessage(this.message)

            this.sendMessage({
                body: _.unescape(this.message.body),
                files: this.message.files
            })
        }
    }
}
</script>
